import { render, staticRenderFns } from "./ElTimer.vue?vue&type=template&id=2bf33c0a"
import script from "./ElTimer.vue?vue&type=script&lang=js"
export * from "./ElTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports